import React, { useState, useRef, useEffect } from "react";
import GoogleMapReact from "google-map-react";
import useSupercluster from "use-supercluster";
// import "./App.css";
import { connect } from 'react-redux';
import Icon from "../../images/map-icon.png"
import Card_Property from '../property-card'
import Card_Development from '../development-card'
import { graphql, useStaticQuery } from 'gatsby';
import mapStyles from '../../components/mapStyles.json';
import { getPrices } from "../../helpers/helper.properties";
import { getPriceForMarker } from "../../helpers/helper.rendering";
import $ from 'jquery'; 

import Loader from "../LoaderMap";

import {addMarker, checkMarker, getMarkers} from "../../helpers/helper.map";
import {REDUX_UPDATE_COORDINATES, getPropertiesAction,changeSelectedAction,changeOffsetPropertiesAction} from '../../redux/propertiesDucks'

function changeFormat(value){
  if(value){
    var convert = value.toString()
    return convert.replace(',','.')
  }
}

const Marker = ({ children }) => children;

function getMap(props) {

  const { realEstate } = useStaticQuery(graphql`
      query {
          realEstate {
              keys{
                google_map
              }
          }
  }`)

  const {properties} = props
  const {loading} = props
  const {settings} = props
  const {dispatch} = props
  const {coordinates} = props
  const {totalCount} = props
  const {selected} = props

  const mapOptions = {
    styles: mapStyles
  };

  const [mapBorder,setMapBorder] = useState()
  const [coordinatesCheck,setCoordinatesCheck] = useState()
  const [sidebar,setSidebar] = useState(false)

  const [offsetInSideBar,setOffsetInSideBar] = useState(0)

  const [points,setPoints] = useState([])

  const mapRef = useRef();
  const google = useRef();
  const [bounds, setBounds] = useState(null);
  const [zoom, setZoom] = useState(13);

  //Variable para abrir card
  const [activeMarker, setActiveMarker] = useState(null);

  const checkAndSetActive = (id) => {
    if(activeMarker === id){
      setActiveMarker(0)
      return null
    }
    setActiveMarker(id)
    return null
  }

  const { clusters, supercluster } = useSupercluster({
    points,
    bounds,
    zoom,
    options: { radius: 100, maxZoom: 20 }
  });

  const searchUnitiesInResults = (id) => {
    let result = properties.filter(property => property.development?.id === id)
    return result
  } 

  const handleGoogleMapApi = (map, google) => {
    const drawingManager =  new google.drawing.DrawingManager({
      drawingMode: google.drawing.OverlayType.MARKER,
      drawingControl: true,
      drawingMode: ['marker'],
      drawingControlOptions: {
        position: google.ControlPosition.TOP_CENTER,
        drawingModes: [
          // google.drawing.OverlayType.CIRCLE,
          google.drawing.OverlayType.POLYGON,
          // google.drawing.OverlayType.MARKER,
          // google.drawing.OverlayType.POLYLINE,
          // google.drawing.OverlayType.RECTANGLE,
        ],
      },
      markerOptions: {
        icon:Icon,
      },
      circleOptions: {
        fillColor: "#FF0000",
        fillOpacity: 0.1,
        strokeWeight: 2,
        clickable: true,
        editable: true,
        zIndex: 1,
      },
    });

    google.event.addListener(drawingManager, 'overlaycomplete', function(event) { //Listener para cuando se hace click en el marcador, se borra el marcador
      var element = event.overlay;
      // handleMapMounted();
      console.log(element.latLngs[0].Gd[0].Gd.map(item => item.Gd))
      google.event.addListener(element, 'click', function(e) {
        element.setMap(null);
      });
    });
    
    var CircleCoordinates = [{ lat:parseFloat(-34.584584182035236), lng:  parseFloat(-58.54748662697551)}]
    var circle = new google.Circle({
      strokeColor: "#FF0000",
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: "#FF0000",
      fillOpacity: 0.35,
      center: CircleCoordinates[0],
      radius: 2000
    })

    // {e: -34.56249228586827, f: -58.54491171417925}
    // {e: -34.59429321641378, f: -58.572720857245656}
    // {e: -34.60489082262427, f: -58.474873872382375}
    // {e: -34.580019636960394, f: -58.473157258612844}
    // {e: -34.56079589452395, f: -58.529290528876516}

    // const triangleCoords = [
    //   {lat: -34.511299898972716, lng: -58.327626548616024},
    //   {lat: -34.6342717479595, lng: -58.75986989578399},
    //   {lat: -34.6342717479595, lng: -58.327626548616024},
    //   {lat: -34.511299898972716, lng: -58.75986989578399},
    // ];
    
    // const rectangle = new google.Rectangle({
    //   strokeColor: "#FF0000",
    //   strokeOpacity: 0.8,
    //   strokeWeight: 2,
    //   fillColor: "#FF0000",
    //   fillOpacity: 0.35,
    //   map,
    //   bounds: {
    //     north: -34.511299898972716,
    //     south: -34.6342717479595,
    //     east: -58.327626548616024,
    //     west: -58.75986989578399,
    //   },
    // });

    // const bermudaTriangle = new google.Polygon({ paths: triangleCoords });
    // bermudaTriangle.setMap(map)

    // rectangle.setMap(map)

    google.event.addListener(map, "click", (e) => {
    })

    drawingManager.setMap(map);
  }
  
  const handleSearchProperties = () => {
    if(mapBorder !== coordinatesCheck){
      dispatch(changeOffsetPropertiesAction(0))
      dispatch(getPropertiesAction())
      setCoordinatesCheck(mapBorder)
    }
  }



  useEffect(() => {
    dispatch(REDUX_UPDATE_COORDINATES(mapBorder))
  },[mapBorder])

  useEffect(() => {
    dispatch(changeSelectedAction(activeMarker))
  },[activeMarker])
  
  useEffect(() => {
    if(selected && !properties.find(element => element.id === selected)?.development?.id > 0){
      const sideBarElement = document.getElementById('sidebarElement');
      sideBarElement.scrollTo({top: 0 , behavior: 'smooth'});
      const cardSelectedElement =$('#card-grid-'+selected).last();  
      var offsetCard = cardSelectedElement?.position().top;
      sideBarElement.scrollTo({top: (sideBarElement.scrollTop + offsetCard - 300) , behavior: 'smooth'});
    }
    if(selected === 0){
      
      setActiveMarker(0)
    }
  },[selected])

  console.log(selected)

  useEffect(() => {
    let points = []
    properties.map(property => ((
      property.development ? 
        <>
          {points.find((element) => element.property.development?.id === property.development?.id) ? null :
            points.push({
              type: "Feature",
              property:property,
              properties: { cluster: false, 
                propId: property.id, 
              address: property.address },
              geometry: {
                type: "Point",
                coordinates: [
                  parseFloat(changeFormat(property.geo_long)),
                  parseFloat(changeFormat(property.geo_lat))
                ]
              }
            })
          }
        </>
        : 
        points.push({
          type: "Feature",
          property:property,
          properties: { cluster: false, 
            propId: property.id, 
          address: property.address },
          geometry: {
            type: "Point",
            coordinates: [
              parseFloat(changeFormat(property.geo_long)),
              parseFloat(changeFormat(property.geo_lat))
            ]
          }
        })
    )));
    setPoints(points)
  },[properties])

  return realEstate.keys.google_map !== '' ?  (
    <>
      <div style={{ height: "82vh", position:"relative", overflow:"hidden", width: "100%" }}>
        <GoogleMapReact
          options={mapOptions}
          bootstrapURLKeys={{ 
            key: realEstate.keys.google_map,
            libraries: ['drawing'].join(','),
            v:'3.32'
          }}
          libraries={['drawing']}
          defaultCenter={{ lat: -34.5728085595, lng:  -58.5437482222 }}
          defaultZoom={13}
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded={({ map, maps }) => {
            mapRef.current = map;
            google.current = maps;
            handleGoogleMapApi(map,maps)
          }}
          onChange={({zoom, bounds}) => {
            setZoom(zoom);
            setBounds([
              bounds.nw.lng, // Oeste
              bounds.se.lat, // Norte
              bounds.se.lng, // Este
              bounds.nw.lat // Norte
            ]);
            setMapBorder([bounds.nw.lng,bounds.se.lng,bounds.se.lat,bounds.nw.lat])
          }}
        >
          {clusters.map(cluster => {
            const [longitude, latitude] = cluster.geometry.coordinates;
            const {cluster: isCluster,point_count: pointCount} = cluster.properties;
            if (isCluster) {
              return (
                <Marker
                  key={`cluster-${cluster.id}`}
                  lat={latitude}
                  lng={longitude}
                >
                  <div
                    className="cluster-marker"
                    style={{
                      width: `${10 + (pointCount / points.length) * 20}px`,
                      height: `${10 + (pointCount / points.length) * 20}px`
                    }}
                    onClick={() => {
                      const expansionZoom = Math.min(
                        supercluster.getClusterExpansionZoom(cluster.id),
                        20
                        );
                      mapRef.current.setZoom(expansionZoom);
                      mapRef.current.panTo({ lat: latitude, lng: longitude });
                    }}
                  >
                    {pointCount}
                  </div>
                </Marker>
              );
            }
            return (
                <Marker key={`crime-${cluster.properties.propId}`} lat={latitude} lng={longitude}>
                  <button onClick={() => checkAndSetActive(cluster.properties.propId) + addMarker(cluster.properties.propId)} id={("marker-" + (cluster.property.development?.id > 0 ? cluster.property.development?.id : cluster.properties.propId))} className={"crime-marker " + ("marker-" + (cluster.property.development?.id > 0 ? cluster.property.development?.id : cluster.properties.propId)) + (cluster.property.development?.id > 0 && searchUnitiesInResults(cluster.property.development?.id)?.length > 1  && " is_development" )}>
                    <div className="center">
                      <i className={(cluster.property.development !== null && searchUnitiesInResults(cluster.property.development?.id)?.length > 1 ? 'icon-marker-emprendimiento' : "icon-marker") + (checkMarker((cluster.property.development?.id)?.length > 1 ? cluster.property.development?.id : cluster.properties.propId) ? ' active ' : '' )}></i>
                      <h5>{cluster.property.development?.id > 0 && searchUnitiesInResults(cluster.property.development?.id)?.length > 1 ? searchUnitiesInResults(cluster.property.development?.id)?.length : getPriceForMarker(getPrices(cluster.property)[0])}</h5>
                    </div>
                  </button>
                  <div className={"card-window " + (cluster.properties.propId !== activeMarker ? 'd-none' : '')}>
                    <div className="card-window-header">
                      {cluster.property.development === null ?
                        <Card_Property inMap={true} property={cluster.property} key={cluster.properties.propId} />
                        : 
                          searchUnitiesInResults(cluster.property.development.id).length > 1 ? //Si hay mas de una propiedad en el mismo desarrollo
                          <Card_Development inMap={true} unities={searchUnitiesInResults(cluster.property.development.id)} development={cluster.property.development} key={cluster.properties.id} />
                          :
                          <Card_Property inMap={true} property={cluster.property} key={cluster.properties.propId} />
                      }
                    </div>
                  </div>
                </Marker>
            );
          })}
        </GoogleMapReact>
        {/* + ( coordinatesCheck ? 'disabled' : '')  */}
        <button className={"btn btn-red btn-search-location position-absolute " + (mapBorder === coordinatesCheck ? ' disabled-map' : '') } onClick={() => handleSearchProperties()}>Sincronizar resultados</button>
        {(loading ? <Loader /> : 'd-none')}
      </div>
      <div id="grid-map">
        <div id="sidebarElement" className={"sidebar-properties " + (sidebar ? '' : 'close-sidebar')}>
          <div onClick={() => setSidebar(!sidebar)} className="open-handle">{"<"}</div>
          <div className="sidebar-properties-header">
            <div className="sidebar-properties-header-title">
            </div>
          </div>
          <div className="sidebar-properties-body">
            {properties.map((property,index) => (
              // selected > 0 ? 
                properties.find(element => element.id === selected)?.development?.id > 0 || property.id === selected || selected === 0 || selected === 'null' || !selected ? 
                <div className="mt-3">
                  <Card_Property grid_map={true} property={property} key={index} />
                  <hr />
                </div>
              :
              <div className="mt-3">
                  <Card_Property opacity={true} grid_map={true} property={property}  key={index} />
                  <hr />
                </div>
            ))}
          </div>
        </div>
      </div>
    </>
  ):'';
}
// 

export default connect(state => ({
  settings: state.settings,
  properties: state.properties.properties,
  totalCount: state.properties.totalCount,
  selected: state.properties.selected,
  loading: state.properties.loading,
  coordinates: state.properties.coordinates,
}),null)(getMap);